"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2EndpointUpdateBilling = void 0;
exports.v2EndpointUpdateBillingSetMock = v2EndpointUpdateBillingSetMock;
exports.v2EndpointUpdateBilling = v2EndpointUpdateBilling;
exports.useQueryV2EndpointUpdateBilling = useQueryV2EndpointUpdateBilling;
exports.useInfiniteQueryV2EndpointUpdateBilling = useInfiniteQueryV2EndpointUpdateBilling;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2EndpointUpdateBillingSetMock(mock) {
    setMock = mock;
}
async function v2EndpointUpdateBilling(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v2/url/update-billing`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2EndpointUpdateBilling = 'cockatoo:v2EndpointUpdateBilling:get';
function useQueryV2EndpointUpdateBilling(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2EndpointUpdateBilling, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV2EndpointUpdateBilling(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2EndpointUpdateBilling, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v2EndpointUpdateBilling(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-endpoint-update-billing.js.map